import {
    type Department,
    type DepartmentParams,
} from 'src/api/DepartmentService';
import { useParams } from 'react-router';
import { useDepartmentEntry } from '@stores/departmentStore';
import { useMemo } from 'react';

const useDepartment = (
    departmentIdParam?: string,
    params?: DepartmentParams,
): {
    department: Department | undefined;
    departmentId: string | undefined;
    isLoadingDepartment: boolean;
    fetchDepartment: () => void;
} => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const effectiveDepartmentId = useMemo(
        () => departmentIdParam ?? departmentId,
        [departmentId, departmentIdParam],
    );

    const {
        response: department,
        isLoading: isLoadingDepartment,
        requestApiCall: fetchDepartment,
    } = useDepartmentEntry(effectiveDepartmentId, params);

    return {
        department,
        departmentId,
        isLoadingDepartment,
        fetchDepartment,
    };
};

export default useDepartment;
